export const TOKEN = 'token';
export const RESY_TOKEN = 'resyToken';
export const VENUE_ID = 'venueId';
